/**
 * Liste gestite dall'amministratore (capitolato ottobre 2026, cap. 1 e 7).
 *
 * Ogni lista è una tabella con la stessa forma:
 *   id INTEGER PRIMARY KEY, nome TEXT NOT NULL UNIQUE, [css TEXT NOT NULL solo se conCss],
 *   valido INTEGER NOT NULL DEFAULT 1, ordine INTEGER NOT NULL DEFAULT 0
 * `LISTE_GESTITE` è la whitelist: l'unica fonte dei nomi di tabella interpolati nell'SQL.
 * Dati puri, usabili anche dal client.
 */
import { z } from 'zod';

/** Unico valore admin che finisce in un attributo `style`: solo esadecimale #rrggbb */
export const CSS_COLORE_REGEX = /^#[0-9A-Fa-f]{6}$/;

export const LISTE_GESTITE = {
  colori: {
    tabella: 'colori_delega',
    titolo: 'Colori delega',
    icona: 'palette',
    conCss: true,
    usi: [
      { tabella: 'deleghe', colonna: 'colore_id' },
      { tabella: 'archivio', colonna: 'colore_id' },
    ],
  },
} as const;

export type NomeLista = keyof typeof LISTE_GESTITE;

export function isNomeLista(v: string): v is NomeLista {
  return Object.hasOwn(LISTE_GESTITE, v);
}

export const ElementoListaSchema = z.object({
  id: z.number(),
  nome: z.string().trim().min(1),
  css: z.string().regex(CSS_COLORE_REGEX).nullable(),
  valido: z.boolean(),
  ordine: z.number().int(),
});

export type ElementoLista = z.infer<typeof ElementoListaSchema>;

export const ElementoListaInsertSchema = ElementoListaSchema.omit({ id: true }).extend({
  css: z.string().regex(CSS_COLORE_REGEX).nullable().optional(),
  valido: z.boolean().default(true),
  ordine: z.number().int().default(0),
});

export type ElementoListaInsert = z.infer<typeof ElementoListaInsertSchema>;
